import { render, staticRenderFns } from "./ViewGroups.vue?vue&type=template&id=50ca1a29"
import script from "./ViewGroups.vue?vue&type=script&lang=js"
export * from "./ViewGroups.vue?vue&type=script&lang=js"
import style0 from "./ViewGroups.vue?vue&type=style&index=0&id=50ca1a29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports